/**
 * @desc 获取登录信息
 */
import { LoginInfo } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type GetLoginInfoParameter = never

const method = 'GET'
const url = '/auth/detail'

export const getLoginInfoApi = (
  params?: GetLoginInfoParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginInfo>({
    method,
    url,
    params,
    ...config
  })
}

getLoginInfoApi.method = method
getLoginInfoApi.url = url
